export { default as ChartBarSquareSolidIcon } from './ChartBarSquareSolidIcon';
